import { useMemo } from "react";
import dayjs from "dayjs";
import { ChevronLeftIcon, ChevronRightIcon } from "@radix-ui/react-icons";
import clsx from "clsx";
import { Link } from "@remix-run/react";

interface EventsHeaderProps {
  date: string;
}

export function EventsHeader({ date }: EventsHeaderProps) {
  const prev = useMemo(
    () =>
      dayjs(date)
        .set("month", dayjs(date).month() - 1)
        .locale("ja")
        .format("YYYY-MM"),
    [date]
  );
  const next = useMemo(
    () =>
      dayjs(date)
        .set("month", dayjs(date).month() + 1)
        .locale("ja")
        .format("YYYY-MM"),
    [date]
  );

  return (
    <header className={clsx("relative", "sm:mb-8")}>
      <div className={clsx("flex", "items-center", "justify-between")}>
        <div className="min-w-0">
          <Link
            to={`/events?d=${prev}`}
            className={clsx(
              "flex",
              "items-center",
              "justify-center",
              "text-blue-600",
              "rounded",
              "w-8",
              "h-8",
              "hover:bg-interaction",
              "focus:bg-interaction"
            )}
          >
            <ChevronLeftIcon width="20" height="20" />
          </Link>
        </div>
        <div className="min-w-0 flex-grow">
          <h2 className={clsx("font-bold", "text-gray-900", "text-lg", "leading-normal", "text-center")}>
            {`${date.split("-")[0]}年${date.split("-")[1]}月`}
          </h2>
        </div>
        <div className="min-w-0">
          <Link
            to={`/events?d=${next}`}
            className={clsx(
              "flex",
              "items-center",
              "justify-center",
              "text-blue-600",
              "rounded",
              "w-8",
              "h-8",
              "hover:bg-interaction",
              "focus:bg-interaction"
            )}
          >
            <ChevronRightIcon width="20" height="20" />
          </Link>
        </div>
      </div>
    </header>
  );
}
